export default {"src":"/_next/static/media/search.7fee1fdf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};